import React from "react";

export default function DayNavigator({
  currentDate,
  onDateChange,
  className = "",
  compact = false,
}) {
  if (!currentDate || typeof onDateChange !== "function") {
    return null;
  }

  function goToPreviousDay() {
    onDateChange(addDays(currentDate, -1));
  }

  function goToNextDay() {
    onDateChange(addDays(currentDate, 1));
  }

  const containerClasses = compact
    ? "rounded-lg border border-gray-200 bg-gray-50 p-2"
    : "rounded-xl border border-gray-200 bg-white p-3 shadow-sm";

  const buttonClasses = compact
    ? "rounded border border-gray-300 px-2 py-1 text-xs font-medium text-gray-700 hover:bg-white"
    : "rounded-md border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50";

  const labelClasses = compact
    ? "text-center text-xs font-semibold text-gray-900"
    : "text-center text-sm font-semibold text-gray-900 md:text-base";

  return (
    <div className={`${containerClasses} ${className}`.trim()}>
      <div className="flex items-center justify-between gap-3">
        <button
          type="button"
          onClick={goToPreviousDay}
          className={buttonClasses}
          aria-label="Vorige dag"
        >
          &lt;
        </button>

        <p className={labelClasses}>
          {formatFullDate(currentDate)} (Week {getISOWeek(currentDate)})
        </p>

        <button
          type="button"
          onClick={goToNextDay}
          className={buttonClasses}
          aria-label="Volgende dag"
        >
          &gt;
        </button>
      </div>
    </div>
  );
}

function addDays(date, amount) {
  const next = new Date(date);
  next.setDate(next.getDate() + amount);
  return next;
}

export function formatFullDate(date) {
  const dayName = date.toLocaleDateString("nl-NL", { weekday: "long" });
  const dayPart = date.toLocaleDateString("nl-NL", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
  return `${capitalize(dayName)} ${dayPart}`;
}

export function getISOWeek(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
}

function capitalize(value) {
  if (!value) return "";
  return value.charAt(0).toUpperCase() + value.slice(1);
}
